import React, { useEffect, useMemo, useState } from 'react';
import './VotePopup.css';

const STORAGE_KEY = 'vote-popup-dismissed';
const REAPPEAR_AFTER_DAYS = 30;
const REAPPEAR_AFTER_MS = REAPPEAR_AFTER_DAYS * 24 * 60 * 60 * 1000;
const QR_CODE_IMAGE = '/assets/qrcode.png';

function VotePopup() {
  const [isOpen, setIsOpen] = useState(false);

  const voteUrl = useMemo(() => {
    return process.env.REACT_APP_MOBILE_APP_VOTE_URL || '';
  }, []);

  useEffect(() => {
    const dismissedAt = localStorage.getItem(STORAGE_KEY);

    if (!dismissedAt) {
      setIsOpen(true);
      return;
    }

    const dismissedTimestamp = Number(dismissedAt);

    if (!Number.isFinite(dismissedTimestamp)) {
      setIsOpen(true);
      return;
    }

    const shouldReappear = Date.now() - dismissedTimestamp >= REAPPEAR_AFTER_MS;

    if (shouldReappear) {
      localStorage.removeItem(STORAGE_KEY);
      setIsOpen(true);
    }
  }, []);

  const closePopup = () => {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
    setIsOpen(false);
  };

  const handleVoteClick = () => {
    if (voteUrl) {
      window.open(voteUrl, '_blank', 'noopener,noreferrer');
    }
    closePopup();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="vote-popup-overlay" onClick={closePopup}>
      <div className="vote-popup" onClick={(event) => event.stopPropagation()}>
        <button className="vote-popup-close" onClick={closePopup} aria-label="Close">×</button>
        <h3 className="vote-popup-title">Support Our Mobile App</h3>
        <p className="vote-popup-text">
          Please vote for our mobile app. Your support helps developers keep building useful applications for everyone with mutual respect between clients and creators.
        </p>
        <div className="vote-popup-qr-wrap">
          <img
            className="vote-popup-qr"
            src={QR_CODE_IMAGE}
            alt="QR code to download the mobile app"
          />
          <p className="vote-popup-qr-text">Scan this QR code to download the mobile app quickly.</p>
        </div>
        <div className="vote-popup-actions">
          <button className="vote-popup-primary" onClick={handleVoteClick}>
            I Want to Vote
          </button>
          <button className="vote-popup-secondary" onClick={closePopup}>
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
}

export default VotePopup;